// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3115":"a437714b","3256":"4d1ebde1","4071":"de65cf2c","4242":"04bfc582","5431":"40d945be","6858":"799e91e8","8110":"a437714b","9307":"568aa915","9757":"b0dd2d0c"}[chunkId] + ".chunk.css";
};